// extracted by mini-css-extract-plugin
module.exports = {"content":"BlastCampaignDetail_content__19YnL","nav":"BlastCampaignDetail_nav__28QBp","actions":"BlastCampaignDetail_actions__1AFWW"};